import TaxiCorporationFleetPartnerUpdateParams from "../../../../../common/services/taxi-corporation/fleet-partner/update/taxi-corporation-fleet-partner-update-params";
import TaxiFleetPartnerEditFormData from "./types/taxi-fleet-partner-edit-form-data";

const create = (
  formData: TaxiFleetPartnerEditFormData,
  fleetPartnerUuid: string,
  taxiCorporationUuid: string,
): TaxiCorporationFleetPartnerUpdateParams => {
  return {
    fleetPartnerUuid,
    name: formData.name,
    notes: formData.notes,
    taxiCorporationUuid,
  };
};

const taxiFleetPartnerUpdateParamsFactory = {
  create,
};

export default taxiFleetPartnerUpdateParamsFactory;
